<template>
    <CardBorder>
        <Button v-if="canCreate" class="btn-success mb-2" size="small" @click="() => onClickAdd()" :class="{ 'mb-4': visibleCardTitle }">
            <CIcon file="plus.svg"></CIcon>
            <span>{{ $t("button.createNew") }}</span>
        </Button>
        <template v-for="(record, index) in lodash.get(data.useForm.modelRef, itemsKey)" :key="record.id || record._id">
            <CardBorder
                v-if="record.isDelete !== true"
                :title="visibleCardTitle ? $t('views.request.informProduct.record', { seq: lodash.get(data.useForm.modelRef, itemsKey).filter(d => d.isDelete !== true).findIndex(d => d === record) + 1 }) : null"
                :style="{ marginBottom: index + 1 < lodash.get(data.useForm.modelRef, itemsKey).length ? '0.5rem !important' : '0 rem !important' }"
            >
                <Button
                    v-if="canDelete"
                    class="btn-danger mb-2"
                    size="small"
                    @click="() => onClickDelete(record, index)"
                    :style="{ position: 'absolute', top: '10px', left: '10px' }"
                >
                    <CIcon file="delete.svg"></CIcon>
                </Button>
                <TemplateBuilder
                    v-if="!isCombineQty || (isCombineQty && data.isCombinedQty)"
                    :rowProp="data.rowProp"
                    :useForm="data.useForm"
                    :fields="
                        createField({
                            props,
                            data: { ...data, productQty: data.productQty?.[record.id] },
                            key: `${itemsKey}.${index}`,
                            items: lodash.get(data.useForm.modelRef, itemsKey),
                            initItems: lodash.get(data.useForm.initialModel, itemsKey),
                            isLoading
                        })
                    "
                    :skeleton="isLoading"
                ></TemplateBuilder>
            </CardBorder>
        </template>
        <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
            <div class="ant-form-explain">
                {{ data.useForm.validateInfos[itemsKey]?.help }}
            </div>
        </div>
    </CardBorder>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { initData, isLoading, createField, callHazSpecies } from "./inform-product.logic";
import lodash from "lodash";
import { Button } from "ant-design-vue";
import { randomUuid } from "../../../../../utils/util";
import { clearRulesStartsWith } from "../../../../../utils/validate";
import { callAddressType, createForm as createFormAddress } from "../../../../../components/address/address.logic";
import { callQuantityUnit } from "./inform-product-qty.logic";

export default defineComponent({
    components: {
        Button,
        //CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../../../../../components/icon/CIcon")),
        CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        viewOnlyInspection: {},
        isCombineQty: {},
        visibleCardTitle: { default: false },
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {},
        informKey: {},
        request: {},
        balanceOnly: { default: false },
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        const onClickAdd = () => {
            Promise.all([callAddressType({}), callHazSpecies({}), callQuantityUnit({})]).then(arr => {
                const addressTypes = arr[0];
                const hazSpecieses = arr[1];
                const quantityUnits = arr[2];
                lodash.get(data.useForm.modelRef, props.itemsKey).push({
                    addresses: ["16", "17", "02"].includes(data.useForm.modelRef.refRequestDoc?.key)
                        ? [{ ...createFormAddress(), refAddressType: addressTypes.find(d => d.key === "1") }]
                        : [],
                    refHazSpecies: ["16", "17", "18"].includes(data.useForm.modelRef.refRequestDoc?.key)
                        ? hazSpecieses.find(d => d.key === "1")
                        : ["19"].includes(data.useForm.modelRef.refRequestDoc?.key)
                        ? hazSpecieses.find(d => d.key === "3")
                        : null,
                    productQties: [
                        {
                            refQtyUnit: quantityUnits.find(d => d.key === "KGM"),
                            refNetWeightUnit: quantityUnits.find(d => d.key === "KGM"),
                            refPackageUnit: quantityUnits.find(d => d.key === "KGM")
                        }
                    ],
                    _id: randomUuid()
                });
            });
        };
        const onClickDelete = (record, index) => {
            if (record.id) {
                record.isDelete = true;
                lodash.remove(record.productQties, d => !d.id);
                record.productQties.forEach(d => (d.isDelete = true));
            } else {
                Promise.resolve()
                    .then(() => clearRulesStartsWith({ useForm: data.useForm, key: `${props.itemsKey}.` }))
                    .then(() => lodash.get(data.useForm.modelRef, props.itemsKey).splice(index, 1));
            }
        };
        if (!data.useForm.modelRef.id && data.useForm.modelRef.refRequestType?.key === "1" && data.useForm.modelRef.refRequestDoc?.key === "02")
            onClickAdd();
        initData({ props, data, refs });
        return { props, data, refs, isLoading, lodash, createField, onClickAdd, onClickDelete };
    }
});
</script>
